var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-editor',{attrs:{"value":_vm.localValue,"useCustomImageHandler":""},on:{"input":function (val) { return _vm.getContent(val); },"image-added":_vm.handleImageAdded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }